import axios from "axios";
import { MessageResponse, MessageRequest, MessageDetailResponse, MessageUpdateRequest } from "../types/MessageTypes";
import axiosInstance from "./axiosInstance";

const API_URL = process.env.REACT_APP_API_URL;

// Fetch all messages
export const getMessages = async (): Promise<MessageResponse[]> => {
  try {
    const response = await axiosInstance.get<MessageResponse[]>(`${API_URL}/messages/detail`, {
        withCredentials: true,
      });
    return response.data;
  } catch (error) {
    console.error("Error fetching messages:", error);
    return [];
  }
};

export const getMessageById = async (id: string): Promise<MessageDetailResponse | null> => {
  try {
    const response = await axiosInstance.get<MessageDetailResponse>(`${API_URL}/messages/${id}/detail`, {
        withCredentials: true,
      });
    return response.data;
  } catch (error) {
    console.error("Error fetching messages:", error);
    return null;
  }
}

export const updateMessage = async (request: MessageUpdateRequest) => {
  try {
    const response = await axiosInstance.put(`${API_URL}/messages`, request, {
      withCredentials: true,
    });

    return response.data;
  } catch (error) {
    console.error("Error updating messages:", error);
    return null;
  }
}

export const addMessage = async (messageData: MessageRequest): Promise<any | null> => {
    try {
      // Convert scheduled times to UTC before sending
      if (messageData.isRecurred && messageData.scheduleCycleList !== null
        && messageData.scheduleCycleList !== undefined && messageData.scheduleCycleList.length > 0) {
        messageData.scheduleCycleList = messageData.scheduleCycleList.map((schedule) => ({
          ...schedule,
          scheduledEndTime: schedule.scheduledEndTime,
          scheduledStartTime: schedule.scheduledStartTime,
        }));
      }
  
      const response = await axiosInstance.post(`${API_URL}/messages/send-message`, messageData, {
        withCredentials: true,
      });
      return response.data;
    } catch (error) {
      console.error("Error adding message:", error);
      return null;
    }
  };

// Delete a message
export const deleteMessage = async (id: number): Promise<void> => {
  try {
    await axiosInstance.delete(`${API_URL}/messages/?id=${id}`, {
        withCredentials: true,
      });
  } catch (error) {
    console.error("Error deleting message:", error);
  }
};

// Convert local datetime to UTC
export const convertToUTC = (localDateTime: string): string => {
  const date = new Date(localDateTime);
  return date.toISOString();
};
